import * as products from "./products";
import * as languageItems from "./languageItems";
import * as nutritionStatements from "./nutritionStatements";
import * as customers from "./customers";
import * as contaminants from "./contaminants";
import * as qualityStatement from "./qualityStatement";
import * as mailSenders from "./mailSenders";
import * as productSearch from "./productSearch";
import * as documents from "./documents";
import * as mailLogItems from "./mailLogItems";
import * as checkout from "./checkout";
import * as userSettings from "./userSettings";
import * as customNutritionStatements from "./customNutritionStatements";

export const autoQ = {
    products,
    languageItems,
    nutritionStatements,
    customers,
    contaminants,
    qualityStatement,
    mailSenders,
    productSearch,
    documents,
    mailLogItems,
    checkout,
    userSettings,
    customNutritionStatements
};
